import axios from 'axios';
import ApiConfig from './ApiConfig';

class OnboardingService {
  baseApiUrl = process.env.ONBOARDING_API_URL;

  getOnboardingData() {
    return axios.get(this.baseApiUrl, ApiConfig.getHttpConfig(true, true));
  }

  updateTask(data) {
    return axios.patch(this.baseApiUrl, data, this.getPatchConfig());
  }

  dismissHotspot(hotspotId) {
    return axios.patch(`${this.baseApiUrl}/hotspot`, hotspotId, this.getPatchConfig());
  }

  getPatchConfig() {
    const patchConfig = ApiConfig.getHttpConfig(true, true);
    patchConfig.headers['Content-Type'] = 'application/json';
    return patchConfig;
  }
}

export default new OnboardingService();



// WEBPACK FOOTER //
// ./src/app/admin/services/api/OnboardingService.js